import React, { useState } from "react";

//
import { Button, Form, Modal } from "react-bootstrap";

//
import Reason from "./delete-modal/Reason";
import Explanation from "./delete-modal/Explanation";
import Password from "./delete-modal/Password";

function DeleteAccountModal() {
  const [show, setShow] = useState(false);
  const [step, setStep] = useState(1);
  const [reason, setReason] = useState({});
  const [explanation, setExplanation] = useState("");

  /**
   * Hide Modal
   * clear data when modal hide
   */
  const hideModal = () => {
    setShow(false);
    setExplanation('')
    setStep(1);
    setReason({});
  };

  const modalTitle = () => {
    if (step === 1) return "Why you wanna delete account?";
    if (step === 2) return "Delete Profile?";
    if (step === 3) return "Submit password";
  };

  const modalSubject = () => {
    if (step === 2)
      return "Can you please share to us what was not working? We are fixing bug as soon as we spot them. If something slipped through our fingers, we’d be so geateful to be aware of it and fix it.";

    if (step === 3)
      return "We need to make sure that this action is concerned by yourself";
  };

  return (
    <>
      <p
        className="text-danger fw-extra-bolder pointer"
        onClick={() => setShow(true)}
      >
        Delete account
      </p>

      <Modal
        centered
        size="lg"
        show={show}
        onHide={hideModal}
        id="delete-account-modal"
      >
        <Modal.Header closeButton>
          <h5>{modalTitle()}</h5>
          {step !== 1 && <p className="subject">{modalSubject()}</p>}
        </Modal.Header>

        <Modal.Body>
          {step === 1 && (
            <Reason
              reason={reason}
              setReason={(reason) => setReason(reason)}
              setStep={(step) => setStep(step)}
              hideModal={() => hideModal()}
            />
          )}
          {step === 2 && (
            <Explanation
              explanation={explanation}
              setExplanation={(text) => setExplanation(text)}
              hideModal={() => hideModal()}
              setStep={(step) => setStep(step)}
            />
          )}

          {step === 3 && (
            <Password
              hideModal={() => hideModal()}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default DeleteAccountModal;
